import { render, staticRenderFns } from "./RemodelationsList.vue?vue&type=template&id=4bf31b28&"
import script from "./RemodelationsList.vue?vue&type=script&lang=js&"
export * from "./RemodelationsList.vue?vue&type=script&lang=js&"
import style0 from "./RemodelationsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports